// extracted by mini-css-extract-plugin
export default {"recos":"u2-z","productCardOverride":"v2-z","rowHasBadge":"w2-z"};